<template>
  <div class="tarifvertrag">
    <div
      class="content"
      v-if="getActiveBereich">
        <tarif-vertrag-selector></tarif-vertrag-selector>
        <div v-if="isActiveTarifvertragEditable" class="draft-banner">
          <span>Dieser Tarifvertrag ist ein <strong>Entwurf</strong> und noch nicht produktiv.</span>
          <button
            class="btn-publish"
            :disabled="publishing"
            @click="publish"
          >{{ publishing ? 'Wird veröffentlicht…' : 'Veröffentlichen' }}</button>
        </div>
        <div class="tab-content">
          <h4>{{ getRegelarbeitszeitString }}</h4>
          <verguetung-table
            v-for="verguetung in getVerguetungen"
            :key="'v-' + verguetung.id"
            :verguetungId="verguetung.id"
          ></verguetung-table>
          <h2 v-if="getVerguetungen.length > 0">Details</h2>
          <information-view
            v-for="information in getInformations"
            :key="'i-' + information.id"
            :information="information"
          ></information-view>
        </div>
    </div>
  </div>
</template>

<script>
  import TarifVertragSelector from './TarifVertragSelector.vue'
  import VerguetungTable from './VerguetungTable.vue'
  import InformationView from './InformationView.vue'

  export default {
    components: {
      InformationView,
      VerguetungTable,
      TarifVertragSelector
    },
    name: 'tarifvertragView',
    data () {
      return {
        publishing: false
      }
    },
    computed: {
      isActiveTarifvertragEditable () {
        return this.$store.getters['tarifvertrag/isActiveTarifvertragEditable']
      },
      getVerguetungen () {
        return this.$store.getters['verguetung/getVerguetungen']
      },
      getInformations () {
        return this.$store.getters['information/getInformations']
      },
      getActiveBereich () {
        return this.$store.getters.getActiveBereichId
      },
      getRegelarbeitszeitString () {
        const activeVertragId = this.$store.getters.getActiveTarifvertragId
        const activeVertrag = this.$store.getters['tarifvertrag/getTarifvertrag'](activeVertragId)
        if (!activeVertrag) {
          return
        }
        let workhours = activeVertrag.workhours
        return workhours.type === 'perWeek'
          ? 'Vertragliche Regelarbeitszeit: ' + workhours.perWeek + 'h pro Woche, rechnerisch ' + workhours.perMonth + 'h pro Monat'
          : 'Vertragliche Regelarbeitszeit: ' + workhours.perMonth + 'h pro Monat, rechnerisch ' + workhours.perWeek + 'h pro Woche'
      }
    },
    methods: {
      async publish () {
        if (this.publishing) return
        const activeVertragId = this.$store.getters.getActiveTarifvertragId
        if (!activeVertragId) return
        if (!window.confirm('Diesen Tarifvertrag wirklich veröffentlichen? Danach ist er produktiv und nicht mehr bearbeitbar.')) {
          return
        }
        this.publishing = true
        try {
          await this.$store.dispatch('tarifvertrag/publishTarifvertrag', activeVertragId)
        } catch (e) {
          window.alert(
            e.response && e.response.status === 403
              ? 'Keine Berechtigung zum Veröffentlichen.'
              : 'Veröffentlichen fehlgeschlagen. Bitte erneut versuchen.'
          )
        } finally {
          this.publishing = false
        }
      }
    }
  }
</script>

<style lang="scss">
  .draft-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 12px 0;
    padding: 10px 14px;
    background: #fdf6ec;
    border: 1px dashed #d39a4a;
    border-radius: 6px;
    color: #8a5a1a;

    .btn-publish {
      flex: none;
      padding: 6px 14px;
      border: none;
      border-radius: 4px;
      background: #4a9d5b;
      color: #fff;
      cursor: pointer;
      font-size: 0.9rem;

      &:hover:not(:disabled) {
        background: #3d8a4d;
      }

      &:disabled {
        opacity: 0.6;
        cursor: default;
      }
    }
  }

  .tarifvertrag {
    position: relative;

    .content {
      position: absolute;
      top: 24px;
      left: 24px;
      right: 24px;
      bottom: 24px;
      height: auto;
      width: auto;
    }
  }
</style>
